<template>
  <transition name="fade">
    <div class="layer" v-if="visible" :style="{zIndex:zIndex,'--z-index':zIndex}">
      <transition name="fade-transform-top">
        <div v-if="dialogShowing" class="dialog" :style="{marginTop:top}">
          <div class="title-line">
            <div class="title">图片选择器</div>
            <div class="max-count-warning">最多选择{{ maxCount }}个图片，已选择{{ selectedImages.length }}个</div>
            <el-button type="primary" icon="el-icon-upload2" @click="uploadImage" :disabled="currentCategory === -1">
              上传图片
            </el-button>
          </div>
          <div class="container">
            <div class="types">
              <div class="type" :class="currentCategory === -1 ? 'selected' : ''" @click="chooseCategory(-1)">全部</div>
              <div class="type" v-for="(category,index) of categories" :key="category.id" @click="chooseCategory(index)"
                   :class="currentCategory === index ? 'selected' : ''">
                {{ category.name }}
              </div>
            </div>
            <div class="images">
              <template v-for="(image,index) in imageList">
                <div class="image" :key="image.id" @click="selectedImage(image)"
                     :class="imageInSelectedIndex(image) !== -1 ? 'selected' : ''">
                  <transition name="fade" :duration="100">
                    <span v-if="imageInSelectedIndex(image) !== -1" class="indexer">
                      {{ imageInSelectedIndex(image) + 1 }}
                    </span>
                  </transition>
                  <div class="image-title">
                    <span v-if="image.name">{{ image.name }}</span>
                    <span v-else>{{ image.filename }}</span>
                  </div>
                  <img :src="image.url" :alt="image.name || image.filename"/>
                  <div class="image-buttons">
                    <el-popover ref="copy-image-popover" trigger="hover" placement="bottom-start"
                                popper-class="--message-box-custom-class">
                      <template slot="default">
                        <div class="detail">
                          <div>复制链接</div>
                        </div>
                      </template>
                      <template slot="reference">
                        <span class="image-button" @click.stop="copyUrl($event, index)">
                          <svg-icon icon="copy"/>
                        </span>
                      </template>
                    </el-popover>

                    <el-popover ref="zoom-image-popover" trigger="hover" placement="bottom-start"
                                popper-class="--message-box-custom-class" width="100px">
                      <template slot="default">
                        <div class="detail">
                          <div>查看大图</div>
                        </div>
                      </template>
                      <template slot="reference">
                        <span class="image-button" @click.stop="showBigImage($event, index)">
                          <svg-icon icon="zoom-in"/>
                        </span>
                      </template>
                    </el-popover>

                    <el-popover ref="image-popover" trigger="hover" placement="bottom-start"
                                popper-class="--message-box-custom-class">
                      <template slot="default">
                        <div class="detail">
                          <div class="detail-line">
                            <div>名称</div>
                            <div>{{ image.alias || image.name || '-' }}</div>
                          </div>
                          <div class="detail-line">
                            <div>文件名</div>
                            <div>{{ image.filename }}</div>
                          </div>
                          <div class="detail-line">
                            <div>大小</div>
                            <div>{{ formatSize(image.size) }}</div>
                          </div>
                        </div>
                      </template>
                      <template slot="reference">
                        <span class="image-button" @click.stop="showImageDetail">
                          <svg-icon icon="more"/>
                        </span>
                      </template>
                    </el-popover>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div class="pager">
            <el-pagination @current-change="getImageList" background :total="totalCount" :current-page="page"
                           :page-size="pageSize"/>
          </div>
          <button-line>
            <el-button type="primary" @click="confirmChoose">确定选择</el-button>
            <el-button @click="close">取消</el-button>
          </button-line>
        </div>
      </transition>

      <el-image-viewer v-if="previewingImage" :z-index="zIndex + 1" append-to-body
                       :url-list="[previewingImage.url]" :on-close="closePreview"/>
      <image-uploader v-model="showUpload" :z-index="zIndex + 1" :category="getCurrentCategory()"
                      @upload="handleUploadComplete"/>
    </div>
  </transition>
</template>

<script>
import ButtonLine from "@/components/ButtonLine";
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import ImageUploader from "@/components/ImageUploader";
import api from "@/utils/api";

export default {
  name: "ImageSelector",
  components: {ImageUploader, ButtonLine, ElImageViewer},
  props: {
    zIndex: {
      type: Number,
      default: 4000
    },
    visible: {
      type: Boolean,
      default: false
    },
    top: {
      type: String,
      default: '3vh'
    },
    maxCount: {
      type: Number,
      default: 1
    }
  },
  model: {
    prop: 'visible',
    event: 'modifyVisible'
  },
  data() {
    return {
      appendedStyle: null,
      dialogShowing: false,
      currentCategory: -1,
      categories: [],
      imageList: [],
      selectedImages: [],
      previewingImage: null,
      showUpload: false,
      totalCount: 0,
      page: 1,
      pageSize: 10
    }
  },
  methods: {
    getCurrentCategory() {
      if (this.currentCategory !== -1 && this.categories[this.currentCategory]) {
        return this.categories[this.currentCategory];
      }
      return null;
    },
    getCategoryList() {
      api.image_getImageCategoryList({}).then(res => {
        this.categories = res.data.data || [];
        this.getImageList(1);
      }).catch(err => {
        console.error('获取分类列表失败:', err);
        this.$message.error('获取分类列表失败');
      });
    },
    getImageList(page) {
      this.page = page;
      let categoryId = null;
      if (this.currentCategory !== -1) {
        let category = this.categories[this.currentCategory];
        if (category) {
          categoryId = category.id;
        }
      }
      api.image_getImageList({
        page: this.page,
        pageSize: this.pageSize,
        categoryId: categoryId
      }).then(res => {
        this.imageList = res.data.data?.list || [];
        this.totalCount = res.data.data?.totalCount || 0;
      }).catch(err => {
        console.error('获取图片列表失败:', err);
        this.$message.error('获取图片列表失败');
      });
    },
    handleUploadComplete() {
      this.getImageList(1);
      this.showUpload = false;
    },
    confirmChoose() {
      this.dialogShowing = false;
      let result = [];
      for (let selectedImage of this.selectedImages) {
        result.push({
          id: selectedImage.id,
          url: selectedImage.url,
          name: selectedImage.name || selectedImage.filename
        });
      }
      setTimeout(() => {
        this.$emit('modifyVisible', false);
        this.$emit('select', result);
      }, 100);
    },
    close() {
      this.previewingImage = null;
      this.showUpload = false;
      this.dialogShowing = false;
      setTimeout(() => {
        this.$emit('modifyVisible', false);
      }, 100);
    },
    closePreview() {
      this.previewingImage = null;
    },
    chooseCategory(index) {
      this.currentCategory = index;
      this.getImageList(1);
    },
    uploadImage() {
      if (this.currentCategory === -1) {
        this.$message.error('请先选择分类');
        return;
      }
      let category = this.categories[this.currentCategory];
      if (!category) {
        this.$message.error('请先选择分类');
        return;
      }
      this.showUpload = true;
    },
    imageInSelectedIndex(image) {
      return this.selectedImages.findIndex(selected => selected.id === image.id);
    },
    selectedImage(image) {
      let index = this.imageInSelectedIndex(image);
      if (index !== -1) {
        this.selectedImages.splice(index, 1);
      } else {
        if (this.selectedImages.length >= this.maxCount) {
          this.$message.warning(`最多选择${this.maxCount}个图片`);
          return;
        }
        this.selectedImages.push({...image});
      }
    },
    showImageDetail(e) {
      e?.stopPropagation();
    },
    formatSize(size) {
      if (!size) return '0byte';
      if (size < 1024) {
        return size + 'byte';
      }
      if (size < 1024 * 1024) {
        return (size / 1024).toFixed(2) + 'kb';
      }
      if (size < 1024 * 1024 * 1024) {
        return (size / 1024 / 1024).toFixed(2) + 'mb';
      }
      return (size / 1024 / 1024 / 1024).toFixed(2) + 'gb';
    },
    showBigImage(e, index) {
      e?.stopPropagation();
      this.previewingImage = this.imageList[index];
    },
    copyUrl(e, index) {
      e?.stopPropagation();
      const url = this.imageList[index]?.url;
      if (!url) {
        this.$message.error('获取图片链接失败');
        return;
      }

      if (!window.navigator.clipboard) {
        this.$message.error('浏览器不支持复制功能');
        return;
      }

      window.navigator.clipboard.writeText(url).then(() => {
        this.$message.success('复制成功');
      }).catch(() => {
        this.$message.error('复制失败');
      });
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(value) {
        if (value) {
          this.selectedImages = [];
          this.currentCategory = -1;
          this.dialogShowing = true;
          this.getCategoryList();
        } else {
          this.dialogShowing = false;
        }
      }
    }
  },
  mounted() {
    let $el = this.$el;
    document.body.appendChild($el);
    let style = document.createElement('style');
    style.innerHTML = '.--message-box-custom-class{z-index:' + (this.zIndex + 1) + ' !important;}';
    this.appendedStyle = style;
    document.head.appendChild(style);
  },
  destroyed() {
    if (this.appendedStyle) {
      document.head.removeChild(this.appendedStyle);
    }
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  left: 0;
  top: 0;
  overflow: auto;
  z-index: var(--z-index, 4000);

  .dialog {
    width: 900px;
    height: 680px;
    background-color: #ffffff;
    border-radius: 10px;
    box-sizing: border-box;
    box-shadow: 0 0 40px 0 #888888;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 10vh;
    padding: 16px;

    .title-line {
      box-sizing: border-box;
      padding: 10px 20px;
      border-bottom: 1px solid #eeeeee;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      height: 56px;
      flex-wrap: nowrap;

      .title {
        font-size: 20px;
        width: 200px;
      }

      .max-count-warning {
        font-size: 12px;
        width: 100%;
      }
    }

    .container {
      height: 460px;
      min-width: 900px;
      margin-top: 20px;
      display: flex;

      .types {
        width: 200px;
        height: 100%;
        background-color: #dddddd;
        overflow-y: auto;

        .type {
          color: #000000;
          box-sizing: border-box;
          padding: 10px;
          cursor: pointer;
          font-size: 14px;
          height: 40px;
          user-select: none;
          transition: 300ms;
        }

        .type.selected {
          background-color: #f0f0f0;
          color: #5d6eee;
        }
      }

      .images {
        width: 680px;
        height: 100%;
        overflow: auto;
        box-sizing: border-box;
        padding: 10px 2px;
        background-color: #fafafa;
        border: 1px solid #aaaaaa;

        .image {
          display: inline-block;
          width: 120px;
          height: 170px;
          background-color: #f0f0f0;
          margin: 0 5px 10px 5px;
          transition: 300ms;
          cursor: pointer;
          border: 1px solid #cccccc;
          position: relative;
          box-sizing: content-box;

          .image-title {
            color: #aaaaaa;
            width: 110px;
            margin-top: 2px;
            margin-left: 5px;
            margin-bottom: 4px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 12px;
            font-style: italic;
          }

          img {
            width: 120px;
            height: 120px;
            object-fit: contain;
            background-color: #ffffff;
          }

          .indexer {
            position: absolute;
            display: flex;
            width: 20px;
            height: 20px;
            background-color: #ffffff;
            border-radius: 50%;
            border: 1px solid #409eff;
            color: #409eff;
            right: -10px;
            top: -10px;
            line-height: 20px;
            font-size: 12px;
            box-sizing: border-box;
            box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.3);
            align-items: center;
            justify-content: center;
            font-weight: bold;
          }

          .image-buttons {
            display: flex;
            justify-content: flex-end;
            margin-top: 4px;
          }

          .image-button {
            user-select: none;
            color: #409eff;
            font-size: 14px;
            margin-right: 6px;
            cursor: pointer;
            display: inline-flex;
            align-items: center;
            padding: 2px 4px;

            &:hover {
              color: #6bb2ff;
              opacity: 0.7;
            }
          }
        }

        .image:hover {
          border: 1px solid #409eff;
        }

        .image.selected {
          box-shadow: 0 0 10px #7cb5f1;
          border: 1px solid #409eff;
        }
      }
    }

    .pager {
      margin-top: 20px;
      display: flex;
      justify-content: center;
    }
  }
}

.detail {
  padding: 6px;
  color: #777777;
  font-size: 12px;

  .detail-line {
    border-bottom: 1px solid #f0f0f0;
    padding: 2px 0;
    display: flex;
    flex-wrap: nowrap;

    div {
      min-width: 50px;
    }

    div:last-child {
      width: 100%;
      text-align: right;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .detail-button {
      color: #409eff;
      cursor: pointer;
      user-select: none;
    }

    .detail-button:hover {
      color: #6bb2ff;
    }
  }
}

.fade-transform-top-leave-active,
.fade-transform-top-enter-active {
  transition: all 300ms;
}

.fade-transform-top-leave-to,
.fade-transform-top-enter {
  opacity: 0;
  transform: translateY(-30px);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>